import React from 'react';
import { XStack, Text } from 'tamagui';

export const ContactElement: React.FC<{
  icon: React.ReactNode;
  value: string;
}> = ({ icon, value }) => (
  <XStack alignItems="center" justifyContent="flex-start" gap="8px">
    {icon}
    <Text fontSize="$8.5" color="$white12">
      {value}
    </Text>
  </XStack>
);
